import { useContext } from "react"
import { DictationConfigContext } from "../components/DictationConfigProvider"

export default function useDictationConfig() {
    const context = useContext(DictationConfigContext)

    if (!context) {
        throw new Error("Debes utilizar el hook useDictationConfig dentro del VideoQuizConfigProvider")
    }

    return context
}